import styled from 'styled-components';
import { H2, paragraph, spacedHeading } from '../../../../theme/typography';
import { themeColor, themeSize } from '../../../../theme/getters';
import { media } from '../../../../theme/media';

export const Container = styled.div`
  max-width: 700px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  ${media.tablet`
    padding: 0 32px;
  `};
`;

export const Title = styled(H2)`
  ${spacedHeading};
  margin-bottom: ${themeSize('contentVerticalMargin')}px;
`;

export const Description = styled.p`
  ${paragraph};
  margin-top: 0;
  margin-bottom: 24px;
  ${media.tablet`
    margin-bottom: 32px;
  `};
  text-align: left;
`;

export const NotesField = styled.textarea`
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  background: none;
  border-radius: 0;
  border: 1px solid ${themeColor('border')};
  min-height: 189px;
  padding: 32px;
  color: ${themeColor('primary')};
`;
